import { Routes } from '@angular/router';
import { Permissions } from 'src/app/core/common';
import { RoutesConstants } from 'src/app/shared/common';
import { PermissionGuard } from 'src/app/shared/guard/permission-guard';

export const SEND_MESSAGES_ROUTES: Routes = [
  {
    path: RoutesConstants.SEND_MESSAGE,
    canActivate: [PermissionGuard],
    loadComponent: () =>
      import('./pages/send-message-page/send-message-page.component').then((x) => x.SendMessagePageComponent),
    data: {
      breadcrumb: {
        label: 'SEND_MESSAGE',
        icon: 'chat_bubble',
      },
      permissions: [Permissions.HomePage_SendMessage]
    },
  },
];
